import { useEffect } from 'react'
import Navigation from '@/components/Navigation'
import { usePageMeta } from '@/hooks/usePageMeta'

const SubscribePage = () => {
  usePageMeta({
    title: 'Subscribe | SPOKE Film',
    description: 'Stay up to date on SPOKE — the firefighter tribute documentary. Get release news, behind-the-scenes updates, and screening announcements.',
  })
  useEffect(() => {
    const existing = document.querySelector('script[data-uid="d9ee4f2ce9"]')
    if (existing) existing.remove()

    const script = document.createElement('script')
    script.src = 'https://filmabee-studios.kit.com/d9ee4f2ce9/index.js'
    script.setAttribute('data-uid', 'd9ee4f2ce9')
    script.async = true
    document.head.appendChild(script)

    return () => {
      const s = document.querySelector('script[data-uid="d9ee4f2ce9"]')
      if (s) s.remove()
    }
  }, [])

  return (
    <div className="min-h-screen bg-[#0a0f1a] text-white">
      <Navigation />

      {/* Hero */}
      <section className="pt-32 pb-12 px-6 md:px-12 text-center">
        <div className="max-w-2xl mx-auto">
          <div className="w-12 h-1 bg-yellow-400 mx-auto mb-8"></div>
          <h1 className="font-montserrat font-black uppercase tracking-wide text-white text-4xl md:text-6xl leading-tight mb-6">
            Stay <span className="text-yellow-400">Connected</span>
          </h1>
          <p className="font-poppins font-light text-gray-300 text-lg md:text-xl leading-relaxed mb-4">
            Be the first to know about screenings, festival news, release dates, and behind-the-scenes updates from the SPOKE team.
          </p>
          <p className="font-poppins text-gray-500 text-sm mb-10">
            No spam. Just real updates about a real film.
          </p>
        </div>
      </section>

      {/* Kit form anchor — the script finds this div by data-uid and injects the form here */}
      <section className="pb-20 px-6 md:px-12">
        <div className="max-w-2xl mx-auto">
          <div data-uid="d9ee4f2ce9"></div>
        </div>
      </section>

      {/* What to expect */}
      <section className="py-16 bg-black">
        <div className="max-w-3xl mx-auto px-6 md:px-12 text-center">
          <div className="w-8 h-[2px] bg-red-600 mb-6 mx-auto"></div>
          <h2 className="font-montserrat font-black uppercase tracking-wide text-white text-2xl mb-10">
            What You'll Hear About
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-8">
            {[
              { icon: '🎬', title: 'Festival News', desc: 'Screening selections, awards, and Q&A appearances.' },
              { icon: '📅', title: 'Release Updates', desc: 'Theatrical dates, city announcements, and how to attend.' },
              { icon: '🎙️', title: 'Podcast & Stories', desc: 'Behind-the-scenes content and firefighter stories from the team.' },
            ].map(({ icon, title, desc }) => (
              <div key={title} className="flex flex-col items-center gap-3">
                <span className="text-3xl">{icon}</span>
                <h3 className="font-montserrat font-black uppercase tracking-wider text-white text-sm">{title}</h3>
                <p className="font-poppins text-gray-400 text-sm leading-relaxed">{desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Footer nudge */}
      <section className="py-12 bg-[#0a0f1a] text-center">
        <p className="font-poppins text-gray-600 text-xs">
          You can unsubscribe at any time. We respect your inbox.
        </p>
      </section>
    </div>
  )
}

export default SubscribePage
